import React, { useEffect, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import { format, add, sub } from "date-fns";
import axios from "axios";
import useAuth from "../hooks/useAuth.js";
import Wrapper from "../components/Wrapper.js";
import Sidebar from "../components/sidebar/Sidebar.js";
import Main from "../components/Main.js";
import Navbar from "../components/navbar/Navbar.js";
import Content from "../components/Content.js";
import useLayout from "../hooks/useLayout.js";

import dashboardItems from "../components/sidebar/dashboardItems.js";

const DashboardLayout = ({ children }) => {
  const state = useAuth();
  const [logsErrorTotal, setLogsErrorTotal] = useState(0);

  useEffect(() => {
    if (state?.tipo !== 1) {
      setLogsErrorTotal(0);
      return;
    }

    const fetchLogsErrorTotal = async () => {
      try {
        const now = new Date();
        const data_inicio = format(sub(now, { days: 7 }), "dd/MM/yyyy HH:mm");
        const data_final = format(add(now, { days: 7 }), "dd/MM/yyyy HH:mm");

        const response = await axios.get(
          `/api/logs/errors/total?data_inicio=${encodeURIComponent(data_inicio)}&data_final=${encodeURIComponent(data_final)}`
        );
        setLogsErrorTotal(Number(response?.data?.message?.total || 0));
      } catch (error) {
        setLogsErrorTotal(0);
      }
    };

    fetchLogsErrorTotal();

    window.addEventListener("logsViewed", fetchLogsErrorTotal);
    return () => {
      window.removeEventListener("logsViewed", fetchLogsErrorTotal);
    };
  }, [state?.tipo]);

  const menuState = useMemo(
    () => ({ ...state, logsErrorTotal }),
    [state, logsErrorTotal]
  );

  const items = dashboardItems(menuState); // Call the function to get the items
  const { scrollContainerRef } = useLayout();

  return (
    <Wrapper>
      <Sidebar items={items} showFooter={false} />
      <Main scrollContainer={scrollContainerRef}>
        <Navbar />
        <Content>
          {children}
          <Outlet />
        </Content>
      </Main>
    </Wrapper>
  )
}

export default DashboardLayout;
